import { render } from "./HiveSpinner.vue?vue&type=template&id=4762ee25"
import script from "./HiveSpinner.vue?vue&type=script&lang=js"
export * from "./HiveSpinner.vue?vue&type=script&lang=js"
script.render = render

export default script